import {getServerAlias} from "./selectors";
import {shallowEqual, useSelector} from 'react-redux';

export const useServerAlias = (): string => {
  return useSelector(getServerAlias, shallowEqual);
};
